<div class="zip-info" [class.show-info]="showInfo()" data-test="zip-info">
  @if (isFinished()) {
    <div class="zip-info-finished">
      <div class="zip-info-title" data-test="zip-info-title">
        {{ `zip.status.${status()}` | translate: { fileName: fileName() } }}
      </div>
      <a-indicator type="done" size="medium" />
    </div>
  } @else {
    <div class="zip-info-title" data-test="zip-info-title">
      <a-loader />
      {{ `zip.status.${status()}` | translate: { fileName: fileName() } }}
    </div>

    <div class="zip-info-progress">
      <a-progress-bar
        [value]="progress()"
        max="100"
        orientation="horizontal"
        data-test="zip-progress-bar"
      />

      @if (status() === 'downloading') {
        <a-button
          size="small"
          variant="text"
          pill
          (click)="onCancel()"
          data-test="download-cancel-button"
        >
          <a-icon name="close" />
        </a-button>
      }
    </div>
  }
</div>
